import BaseElement from '../structure/BaseElement';
import merge from 'lodash/merge';
import AuthorX from '../types/AuthorX';
import get from 'lodash/get';
import { Reference } from '@/fhirworks';

/**
 * @property {AuthorX} author
 * @property {String} time
 * @property {String} text
 */
export default class Annotation extends BaseElement {
    static __className = 'Annotation';

    __objectStructure = {
        author: AuthorX,
        time: String,
        text: String,

        // Extensions
        formTitle: String,
        isDraft: Boolean,
        reviewType: String,
        questionnaireResponse: Reference,
    };

    constructor(constructJson, className = 'Annotation') {
        super(constructJson, className);

        let fhirAuthorReference = get(constructJson, 'authorReference', undefined);
        if (fhirAuthorReference) {
            this.authorReference = fhirAuthorReference;
        }

        let fhirAuthorString = get(constructJson, 'authorString', undefined);
        if (fhirAuthorString) {
            this.authorString = fhirAuthorString;
        }

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    get authorReference() {
        if (!this.author) {
            return undefined;
        }
        return this.author.authorReference;
    }
    set authorReference(value) {
        if (!this.author) {
            this.author = new AuthorX();
        }
        this.author.authorReference = value;
    }

    get authorString() {
        if (!this.author) {
            return undefined;
        }
        return this.author.authorString;
    }
    set authorString(value) {
        if (!this.author) {
            this.author = new AuthorX();
        }
        this.author.authorString = value;
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
